const ACCESS_TOKEN_KEY = "dboul-webchat-A-token";
const ACCESS_HEADER = "X-SC-AT";

export const API = {
  ACCESS_TOKEN_KEY,
  ACCESS_HEADER,
};
